import $ from 'jquery';
import Swiper, { Pagination, Autoplay, EffectCoverflow } from 'swiper';

const number_of_columns = $("#number_of_columns").text();

// Asset Carousel
var swiper = new Swiper(".asset-carousel .swiper", {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    720: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: number_of_columns,
    },
  }
});

// Testimonial Carousel
var swiper = new Swiper(".testimonial-carousel .swiper", {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  spaceBetween: 20,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.25,
    },
    992: {
      slidesPerView: 'auto',
      pagination: false,
    },
  }
});


//tabs-card carousel
var section = document.getElementById('tab-cards');
var cardSwiper; 

$(".cards-tabs .nav .nav-link").click(function(){
  const navIndex = $(this).index();
  const activeSlide = document.querySelector(`.tab-pane[tabIndex="${navIndex}"] .swiper-slide[data-swiper-slide-index="0"]`);
  if(activeSlide){
    const bgImage = activeSlide.dataset.bgImage;
    section.style.backgroundImage = `url(${bgImage})`;
  }

  cardSwiper.update();
});

$(".cards-carousel .swiper-slide").click(function () {
  const index = $(this).index();
  cardSwiper.slideToLoop(index); 
});

cardSwiper = new Swiper(".cards-carousel .swiper", {
  modules: [Autoplay, EffectCoverflow],
  effect: "coverflow",
  grabCursor: true,
  slideToClickedSlide: true,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2.5,
    slideShadows: true
  },
  on: {
    slideChange: function() {
      const tab_index = this.realIndex;
      const activeSlide = this.slides[tab_index];

      if(activeSlide){
        const bgImage = activeSlide.dataset.bgImage;
        section.style.backgroundImage = `url(${bgImage})`;
      }
    }
  },
  spaceBetween: 0,
  loop: true,
  slidesPerView: 1.1,
  breakpoints: {
    640: {
      slidesPerView: 1.5
    },
    1024: {
      slidesPerView: 2.5
    }
  }
});

 
